/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, { type MoreProjectsQuery } from './__generated__/MoreProjectsQuery.graphql';

import type { ExtraProps } from './types.tsx';

type EntryPointParams = { cloudId: string; currentURL: string } & ExtraProps;

type Queries = { moreProjects: MoreProjectsQuery };

type MoreProjectsEntrypointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

export const MoreProjectsEntrypoint: EntryPoint<MoreProjectsEntrypointComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<MoreProjectsEntrypointComponent>(
			/* webpackChunkName: "async-more-projects-flyout" */ './MoreProjects.tsx',
		),
		getPreloadProps: ({ cloudId, currentURL }: EntryPointParams) => ({
			queries: {
				moreProjects: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						currentURL,
					},
				},
			},
			extraProps: {},
		}),
	});
